import Button from '@mui/material/Button';

const SecondaryButton = (props) => {
  return (
    <Button
      id={props.id ? props.id : ''}
      variant="contained"
      onClick={props.onClick}
      className={`secondary-button ${props.className ? ` ${props.className}` : ''}`}
      disabled={props.disabled ? props.disabled : false}
    >
      {props.text}
    </Button>
  )
}

export default SecondaryButton;
